// Define an enum for content types
enum ContentTypes {
  UNKNOWN = "UNKNOWN",
  TEXT = "TEXT",
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
  AUDIO = "AUDIO",
  DOCUMENT = "DOCUMENT",
  PDF = "PDF",
  NOTE = "NOTE",
  SURVEY = "SURVEY",
}

// Updated function using the ContentType enum
export const getContentType = (mimeType: string): ContentTypes => {
  if (!mimeType) return ContentTypes.UNKNOWN;

  if (mimeType.startsWith("text/")) {
    return ContentTypes.TEXT;
  }
  if (mimeType.startsWith("image/")) {
    return ContentTypes.IMAGE;
  }
  if (mimeType.startsWith("video/")) {
    return ContentTypes.VIDEO;
  }
  if (mimeType.startsWith("audio/")) {
    return ContentTypes.AUDIO;
  }

  // Separate PDF type from document MIME types
  if (mimeType === "application/pdf") {
    return ContentTypes.PDF;
  }

  // Treat common document MIME types
  const documentTypes = [
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  ];

  if (documentTypes.includes(mimeType)) {
    return ContentTypes.DOCUMENT;
  }

  // Default category for unknown types
  return ContentTypes.UNKNOWN;
};
